import * as React from 'react'
import { useLocation } from 'react-router-dom';

import RedirectPage from '../component/redirectPage';

const DiagnosticCreatePage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const atParam = searchParams.get('at');

  return <RedirectPage pageRedirectPath="/irtech" atParam={atParam} />;
};

export default DiagnosticCreatePage;